import { Toaster } from "../types/Toaster.types";

//Initial value for Toaster Object
export const toasterInitialData: Toaster = {
  id: 0,
  array: [],
  text: "",
  type: "error",
  size: "large",
  titleLevel: 1,
  width: "auto",
  title: "",
};